module.exports = __webpack_public_path__ + "static/new-core-alternative-632743e9125b1b2f80e532f5b7b8e985.png";